<template>
	<transition name="genre">
		<div class="genre">
			<button @click="back">back</button>
			<button @click="newGenre"
			        v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'">new genre</button>
			<p>Жанры</p>
			<div class="container">
				<div class="table"
				     v-for="(i, j) in genre"
				     :key="j.order_no">
					<p class="order">{{i.order_no}}</p>
					<p>{{i.name}}</p>
					<p>{{i.display_name}}</p>
					<input type="button"
					       title="редактировать"
					       @click="editGenre"
					       v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'">
				</div>
			</div>
			<!--<button @click="save"-->
			<!--v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'">save</button>-->
		</div>
	</transition>
</template>
<script>
	import { mapGetters, mapMutations } from "vuex";
	import { performRequest }           from "../script/ws/wsclient";

	export default {
		name:     "Genre",
		data() {
			return {
				genre: []
			};
		},
		mounted() {
			this.genre = this.getGenre;
		},
		beforeMount() {
			performRequest(
				{
					section: "tvcontent.genre",
					name:    "getGenreList"
				},
				{
					operator: this.getViewUser
				},
				a => {
					if (a.code === 200) {
						this.setGenre(a.data);
					} else {
						console.log("ошибка при получении жанров");
					}

				}
			);
		},
		methods:  {
			...mapMutations(["setSelectedGenre", "setGenre"]),
			back() {
				this.$router.push("/playlist");
			},
			newGenre() {
				this.$router.push("/new_genre");
			},
			save() {
				console.log("save");
				this.$router.push("/playlist");
			},
			editGenre(e) {
				this.getGenre.forEach((item, i) => {
					if (
						item.order_no === +e.target.parentNode.firstChild.innerText
					) {
						this.setSelectedGenre({ item, i });
					}
				});

				this.$router.push("/edit_genre");
			}
		},
		computed: {
			...mapGetters([
				"getGenre",
				"getUserRights",
				"getReqUserRole",
				"getViewUser"
			])
		},
		watch:    {
			"$store.state.genre"() {
				this.genre = this.getGenre;
			}
		}
	};
</script>
<style scoped lang="scss">
	.genre {
		background-color: rgba(238, 238, 200, 0.8);
		box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.4), 1px 1px 5px #333;
		/*padding: 0.5rem 0.5rem 1rem 0.5rem;*/
		height: calc(100vh - 5rem);
		overflow: auto;
		position: absolute;
		margin-top: 4rem;
		width: 90%;
		right: 50%;
		transform: translateX(50%);
		flex-direction: column;
		
		& > p {
			float: right;
			margin: 0.5rem;
			padding-right: 3%;
			.bold {
				font-weight: bold;
			}
		}
		
		button {
			background: #bbf291;
			border-radius: 0.2rem;
			line-height: 1.8rem;
			border: none;
			outline: none;
			height: 2.5rem;
			padding: 0.2rem 1rem;
			transition: all 0.2s;
			cursor: pointer;
			margin: 1rem;
			
			&:hover {
				background: #78956b;
				color: white;
				
				&:active {
					box-shadow: 0 0 1rem #967068;
				}
			}
		}
		
		.container {
			width: 90%;
			margin-left: 50%;
			transform: translateX(-50%);
			display: table;
			.table {
				display: table-row;
				position: relative;
				transition: all .3s;
				cursor: default;
				
				&:hover {
					background-color: #c7bae0;
				}
				p {
					clear: both;
					width: calc((100% / 2));
					display: table-cell;
					padding-left: 2rem;
					vertical-align: top;
					padding-top: 6px;
					height: 2rem;
				}
				p.order {
					
					width: 5rem;
				}
				input[type="button"] {
					outline: none;
					border: none;
					background: url("../../static/edit.png") no-repeat center;
					background-size: 75%;
					width: 28px;
					height: 28px;
					cursor: pointer;
				}
			}
		}
	}
	@media (max-width: 620px) {
		.genre {
			min-height: calc(100vh - 9rem);
			height: auto;
			min-width: 30rem;
			margin-top: 8rem;
		}
	}
	.genre-enter-active {
		transition: all 0.5s ease;
	}
	.genre-leave-active {
		transition: all 0.5s ease;
	}
	.genre-enter, .genre-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/Genre.vue